import { WISHLIST_FEATURE_STATUS } from 'src/constants/wishlist';
import WishlistHeartIconWithDot from './WishlistHeartIconWithDot';
import { useSelector } from 'react-redux';

const WishlistHeartIcon = ({ color = 'white', iconSize = 20, isActive = true }) => {
  const { isWishlistItemPresentOnStore, wishlistFeatureActive } = useSelector(
    (state) => ({
      isWishlistItemPresentOnStore: state.wishlistReducer?.wishlistItemCount,
      wishlistFeatureActive: state.storeReducer?.store?.services?.wishlist_flag,
    })
  );
  const circleColor = color === 'white' ? 'black' : 'white';
  if (wishlistFeatureActive !== WISHLIST_FEATURE_STATUS.WISHLIST_ACTIVE) return null;
  return !isWishlistItemPresentOnStore || !isActive ? (
    <svg
      width="30"
      height="29"
      viewBox="0 0 30 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(3.5, 3)">
        <path
          d="M11.7352 21.5609L10.4015 20.3619C8.39853 18.5448 6.7421 16.9833 5.43227 15.6775C4.12244 14.3715 3.08448 13.2092 2.3184 12.1906C1.55231 11.1722 1.01712 10.243 0.712823 9.40326C0.408323 8.56367 0.256073 7.71169 0.256073 6.84733C0.256073 5.1325 0.834261 3.6968 1.99064 2.54023C3.14721 1.38385 4.58291 0.805664 6.29774 0.805664C7.35261 0.805664 8.34949 1.05237 9.28836 1.54577C10.2272 2.03917 11.0429 2.74675 11.7352 3.66851C12.4276 2.74675 13.2432 2.03917 14.1821 1.54577C15.121 1.05237 16.1179 0.805664 17.1727 0.805664C18.8876 0.805664 20.3233 1.38385 21.4798 2.54023C22.6362 3.6968 23.2144 5.1325 23.2144 6.84733C23.2144 7.71169 23.0622 8.56367 22.7577 9.40326C22.4534 10.243 21.9182 11.1722 21.1521 12.1906C20.386 13.2092 19.35 14.3715 18.0439 15.6775C16.7381 16.9833 15.0798 18.5448 13.0689 20.3619L11.7352 21.5609ZM11.7352 19.1119C13.6686 17.3723 15.2595 15.8812 16.5082 14.6387C17.7568 13.3963 18.7436 12.317 19.4686 11.4006C20.1936 10.4843 20.697 9.6706 20.979 8.9595C21.2609 8.24859 21.4019 7.54454 21.4019 6.84733C21.4019 5.639 20.9991 4.63205 20.1936 3.8265C19.388 3.02094 18.3811 2.61816 17.1727 2.61816C16.2186 2.61816 15.3367 2.88883 14.5271 3.43016C13.7177 3.9717 13.0768 4.72499 12.6043 5.69005H10.8661C10.3858 4.71714 9.7429 3.96193 8.93734 3.42442C8.13179 2.88692 7.25192 2.61816 6.29774 2.61816C5.09706 2.61816 4.09203 3.02094 3.28265 3.8265C2.47326 4.63205 2.06857 5.639 2.06857 6.84733C2.06857 7.54454 2.20955 8.24859 2.49149 8.9595C2.77343 9.6706 3.27691 10.4843 4.00191 11.4006C4.72691 12.317 5.71371 13.3944 6.96232 14.6329C8.21093 15.8715 9.80191 17.3645 11.7352 19.1119Z"
          fill={color}
        />
      </g>
    </svg>
  ) : (
    <WishlistHeartIconWithDot heartColor={color} circleColor={circleColor} />
  );
};

export default WishlistHeartIcon;
